'use client';

import { useEffect, useRef, type FC, type ReactNode } from 'react';
import { cn } from '../../../utils/cn';

const GAP_PX = 16;

// WHY: колонка выше окна при top: 16px прятала бы низ, а прилипшая низом — верх; top двигается вместе с прокруткой в пределах [окно − высота − отступ, отступ]: вниз колонка едет со страницей, пока не покажется низ, вверх — пока не покажется верх
export const WikiStickySide: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const side = ref.current;
    const scroller = side?.closest<HTMLElement>('[data-screen-scroll]');
    if (!side || !scroller) return;
    let top = GAP_PX;
    let lastScroll = scroller.scrollTop;
    const lowest = () => Math.min(GAP_PX, scroller.clientHeight - side.offsetHeight - GAP_PX);
    const apply = () => {
      side.style.top = `${top}px`;
    };
    const onScroll = () => {
      const delta = scroller.scrollTop - lastScroll;
      lastScroll = scroller.scrollTop;
      top = Math.max(lowest(), Math.min(GAP_PX, top - delta));
      apply();
    };
    const onResize = () => {
      top = Math.max(lowest(), Math.min(GAP_PX, top));
      apply();
    };
    onResize();
    scroller.addEventListener('scroll', onScroll, { passive: true });
    const observer = new ResizeObserver(onResize);
    observer.observe(side);
    observer.observe(scroller);
    return () => {
      scroller.removeEventListener('scroll', onScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={ref} className={cn('lg:sticky lg:top-4 lg:self-start', className)}>
      {children}
    </div>
  );
};
